import React from "react"
import { formatDateTime } from "../transactions/format"

// Lifecycle timeline (doc 06 detail), newest-first. Event labels are I18n'd via
// copy.events keyed by the raw event type; an unmapped type falls back to itself.
export function EventTimeline({ timeline, copy }) {
  const c = copy.timeline
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{c.heading}</h2>
      {timeline.length === 0 ? (
        <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">{c.empty}</p>
      ) : (
        <ol className="mt-4 space-y-4">
          {timeline.map((e, i) => (
            <li key={`${e.type}-${e.at}-${i}`} className="flex gap-3">
              <div className="mt-1.5 h-2 w-2 flex-none rounded-full bg-brand-500" />
              <div>
                <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {c.events[e.type] || e.type}
                  {e.plan ? ` · ${e.plan}` : ""}
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400">{formatDateTime(e.at)}</div>
                {e.reason ? (
                  <div className="mt-1 text-xs text-gray-600 dark:text-gray-400">
                    {c.reasonLabel}: <span className="font-medium">{e.reason}</span>
                  </div>
                ) : null}
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  )
}
